import React from "react";
import EventBox from "./EventBox.jsx";

function EventsTable({ events }) {
    return (
        <div className="mx-auto w-full max-w-3xl px-4">
            {events.length === 0 ? (
                <div className="flex items-center justify-center py-12">
                    <p className="text-gray-500 italic text-lg">No recorded events on this date</p>
                </div>
            ) : (
                <div className="flex flex-col space-y-2">
                    {events.map((event) => (
                        <EventBox key={event.Id} event={event} />
                    ))}
                </div>
            )}
        </div>
    );
}

export default EventsTable;
